import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { toHttpParamsObject } from '@capital-access/common/utils';
import { TARGETING_API_BASE_URL } from '../constants';
import { ExcelExportModel } from '../models';

@Injectable()
export class TargetingExportRepository {
  public getExcelReport(exportRequest: ExcelExportModel, securityId: number): Observable<HttpResponse<Blob>> {
    return this.http.post(`${TARGETING_API_BASE_URL}/export`, exportRequest, {
      responseType: 'blob',
      observe: 'response',
      params: toHttpParamsObject({ securityId })
    });
  }

  constructor(private http: HttpClient) {}
}
